export interface Result<T> {
  data: T | null;
  error: Error | null;
}

export const ok = <T>(data: T): Result<T> => ({ data, error: null });
export const err = <T = never>(error: unknown): Result<T> => ({
  data: null,
  error: error instanceof Error ? error : new Error(String(error ?? "Unknown error")),
});

export const wrap = async <T>(fn: () => Promise<T>): Promise<Result<T>> => {
  try {
    const data = await fn();
    return ok(data);
  } catch (error) {
    return err<T>(error);
  }
};
